class ProductHelper {
  constructor(productConfig) {
    this.productConfig = productConfig;
  }

  fetchPlanBasedOnId(planId) {
    return this.productConfig.plans.filter(plan => plan.id == planId)[0];
  }

  fetchAddonBasedOnId(addonId) {
    return this.productConfig.addons.filter(addon => addon.id == addonId)[0];
  }
}

export default ProductHelper


// WEBPACK FOOTER //
// ./src/helpers/product-helper.js